import { gql } from '@apollo/client';

export const ADD_CONTENT_BY_WRITER_ID = gql`
  mutation createContent(
    $titleId: String
    $writerId: String
    $editorId: String
    $titleContent: String
    $content: String
    $featuredImage: String
    $statusAtWP: Float
    $permalink: String
    $sendWp: Boolean
    $smallSeoToolsReport: String
    $theContentWasReproved: Boolean
    $usedKeywords: String
  ) {
    createContent(
      input: {
        titleId: $titleId
        writerId: $writerId
        editorId: $editorId
        titleContent: $titleContent
        content: $content
        featuredImage: $featuredImage
        statusAtWP: $statusAtWP
        permalink: $permalink
        sendWp: $sendWp
        smallSeoToolsReport: $smallSeoToolsReport
        theContentWasReproved: $theContentWasReproved
        usedKeywords: $usedKeywords
      }
    ) {
      id
      titleId
      title
      writerId
      titleContent
      content
      photos
      finishAt
      created
      featuredImage
      smallSeoToolsReport
    }
  }
`;

export const EDIT_CONTENT_BY_WRITER_ID = gql`
  mutation updateContent(
    $id: String!
    $writerId: String
    $editorId: String
    $titleId: String!
    $titleContent: String!
    $content: String!
    $featuredImage: String
    $statusAtWP: Float
    $permalink: String
    $sendWp: Boolean
    $smallSeoToolsReport: String
    $theContentWasReproved: Boolean
    $usedKeywords: String
  ) {
    updateContent(
      id: $id
      input: {
        titleId: $titleId
        writerId: $writerId
        editorId: $editorId
        titleContent: $titleContent
        content: $content
        featuredImage: $featuredImage
        statusAtWP: $statusAtWP
        permalink: $permalink
        sendWp: $sendWp
        smallSeoToolsReport: $smallSeoToolsReport
        theContentWasReproved: $theContentWasReproved
        usedKeywords: $usedKeywords
      }
    ) {
      id
      titleId
      title
      writerId
      titleContent
      content
      photos
      finishAt
      created
      featuredImage
      statusAtWP
      smallSeoToolsReport
    }
  }
`;

export const SAVE_CONTENT_BY_WRITER_ID = gql`
  mutation saveContent(
    $id: String!
    $content: String!
    $editorId: String
    $featuredImage: String
    $permalink: String!
    $smallSeoToolsReport: String
    $statusAtWP: Float
    $titleContent: String!
    $titleId: String!
    $usedKeywords: String
    $writerId: String!
  ) {
    saveContent(
      id: $id
      input: {
        content: $content
        editorId: $editorId
        featuredImage: $featuredImage
        permalink: $permalink
        smallSeoToolsReport: $smallSeoToolsReport
        statusAtWP: $statusAtWP
        titleContent: $titleContent
        titleId: $titleId
        usedKeywords: $usedKeywords
        writerId: $writerId
      }
    ) {
      id
      titleId
      title
      writerId
      titleContent
      content
      photos
      finishAt
      created
      featuredImage
      statusAtWP
      smallSeoToolsReport
    }
  }
`;

export const PUBLISH_CONTENT = gql`
  mutation publishContent($id: String!) {
    publishContent(id: $id) {
      id
    }
  }
`;
